<div class="popup">
    <div class="modal-header">
        <div class="modal-headerTitle" style="padding-left:10px;padding-top:10px;">Sort Order - Custom</div>
    </div>
    <div class="modal-body" style="padding:10px;margin-bottom:70px;">
        <div>
            The custom order for each class can be set by selecting Set Custom Sort Order for Students from the Tools menu.
        </div>
        <div style="padding-top:10px;">
            For classes where a custom order has not been defined, the students will be sorted alphabetically by name.
        </div>
    </div>    
    <div class="sis-app-footer">
            <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
    </div>
</div>
        
    
    